import React, { useState, useContext } from 'react'
import Box from '@material-ui/core/Box'
import FormControl from '@material-ui/core/FormControl'
import FormGroup from '@material-ui/core/FormGroup'
import FormLabel from '@material-ui/core/FormLabel'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import OutlinedInput from '@material-ui/core/OutlinedInput'
import Button from '@material-ui/core/Button'
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown'
import KeyboardArrowUp from '@material-ui/icons/KeyboardArrowUp'
import BrokerAPI from 'config/api/BrokerAPI'
import AdminAPI from 'config/api/AdminAPI'
import { onError } from 'config/lib/errorLib'
import { NotificationManager } from 'react-notifications'

import DetailsContext from 'config/context/DetailsContext'

function PetQuoteDetails(props) {
    const api = props.admin ? new AdminAPI() : new BrokerAPI()
    const companyDetails = useContext(DetailsContext)
	const companyId = companyDetails.companyId || props.companyId

    const quote = props.lead.quote
    
    const [petType, setPetType] = useState(quote.petType || '')
    const [petPedigree, setPetPedigree] = useState(quote.petPedigree || '')
    const [petBreed, setPetBreed] = useState(quote.petBreed || '')
    const [petWeight, setPetWeight] = useState(quote.petWeight || '')
    const [petAge, setPetAge] = useState(quote.petAge || '')
    const [premium, setPremium] = useState(quote.premium || '')
    const [showContent, setShowContent] = useState(props.showQuoteContent)
 
    async function updateQuote() {
        try {
            let quote = {
                petType,
                petPedigree,
                petBreed,
                petWeight,
                petAge,
                premium
            }
            
            let result = null
            if (props.admin) {
                result = await api.updateLeadQuote(props.lead.date, props.lead.leadId, quote)
            }
            else {
                result = await api.updateLeadQuote(companyId, props.lead.product, props.lead.phone, quote)
            }

            props.updateLead(result)
            NotificationManager.success('Details updated')
            setShowContent(false)
        } catch(e) {
            onError(e)
        }
    }
    
    return (
        <Card>
            <CardHeader
                subheader={
                    <Grid
                        container
                        component={Box}
                        alignItems='center'
                        justifyContent='space-between'
                    >
                        <Grid item xs='auto'>
                            <Box
                                component={Typography}
                                variant='h3'
                                marginBottom='0!important'
                            >
                                Pet Insurance Details
                            </Box>
                        </Grid>
                        <Grid item xs='auto'>
                            <Box>
                                {showContent ? (
                                    <KeyboardArrowUp />
                                ) : (
                                    <KeyboardArrowDown />
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                }
                onClick={() => setShowContent(!showContent)} 
                style={{cursor: 'pointer'}}
            >
            </CardHeader>
            
            {showContent &&
                <CardContent>
                    <Grid container>
                        <Grid item xs={12} lg={6}>
                            <FormGroup>
                                <FormLabel>Pet Type</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                    //marginBottom='1rem!important'
                                >
                                    <OutlinedInput
                                        fullWidth
                                        type='text'
                                        value={petType}
                                        onChange={(e) => setPetType(e.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                            <FormGroup>
                                <FormLabel>Pet Pedigree</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                    //marginBottom='1rem!important'
                                >
                                    <OutlinedInput
                                        fullWidth
                                        type='text'
                                        value={petPedigree}
                                        onChange={(e) => setPetPedigree(e.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                            <FormGroup>
                                <FormLabel>Pet Breed</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                    //marginBottom='1rem!important'
                                >
                                    <OutlinedInput
                                        fullWidth
                                        type='text'
                                        value={petBreed}
                                        onChange={(e) => setPetBreed(e.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                            <FormGroup>
                                <FormLabel>Pet Weight</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                    //marginBottom='1rem!important'
                                >
                                    <OutlinedInput
                                        fullWidth
                                        type='text'
                                        value={petWeight}
                                        onChange={(e) => setPetWeight(e.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                            <FormGroup>
                                <FormLabel>Pet Age</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                    //marginBottom='1rem!important'
                                >
                                    <OutlinedInput
                                        fullWidth
                                        type='text'
                                        value={petAge}
                                        onChange={(e) => setPetAge(e.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>

                        <Grid item xs={12} lg={6}>
                            <FormGroup>
                                <FormLabel>{companyId === 'cib' ? 'Monthly Income/Commission (€)' : 'Monthly Premium (€)'}</FormLabel>
                                <FormControl
                                    variant='filled'
                                    component={Box}
                                    width='100%'
                                    autoFocus
                                    //marginBottom='1rem!important'
                                >
                                    <OutlinedInput
                                        fullWidth
                                        type='number'
                                        value={premium}
                                        onChange={(e) => setPremium(e.target.value)}
                                    />
                                </FormControl>
                            </FormGroup>
                        </Grid>
                        
                        <Grid item xs={12} lg={12}>
                            <Grid container justifyContent='space-between'>
                                <Grid item>
                                    {/*
                                    <Button
                                        onClick={() => setShowQuotesModal(true)}
                                        color='primary'
                                        disabled
                                    >
                                        Generate Quotes
                                    </Button>
                                    */}
                                </Grid>
                                {!props.admin &&
                                    <Grid item>
                                        <Button
                                            component={Box}
                                            color='primary'
                                            variant='contained'
                                            size='medium'
                                            disabled={false}
                                            onClick={() => updateQuote()}
                                        >
                                            Save
                                        </Button>
                                    </Grid>
                                }
                            </Grid>
                        </Grid>
                    </Grid>

                    {/*showQuotesModal &&
                        <QuotesModal 
                            isOpen={showQuotesModal}
                            close={() => setShowQuotesModal(false)}
                            clientDetails={props.clientDetails}
                            application={application}
                            updateApplication={(provider, premium, noPeople, coverAmount, coverAmount2, illnessCover, illnessCoverAmount, illnessCoverAmount2, policyTerm, convertibleOption, indexation) => updateApplication(provider, premium, noPeople, coverAmount, coverAmount2, illnessCover, illnessCoverAmount, illnessCoverAmount2, policyTerm, convertibleOption, indexation)}
                            type={props.type}
                        />
                    */}
                </CardContent>
            }
        </Card>
    )
}

export default PetQuoteDetails